import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";

class Awards extends React.Component {
  render() {
    const accentLinkStyle = { color: "#168f7c", textDecoration: "none" };

    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />

          <div className="row">
            <div className="mt-3" id="awards">
              <h5>Awards</h5>
              <hr />

              <ul className="list-group">
                {/* Med4Dev */}
                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-12 mb-2">
                      <h4>Med4Dev India Israel International Hackathon</h4>
                      <div style={{ fontSize: ".9em", color: "#707070" }}>
                        Hackathon Winner
                      </div>
                    </div>

                    <div className="col-12">
                      <ul>
                        <li>
                          Built a proof of concept for an online crowdfunding
                          platform to support cancer patients and improve access
                          to affordable care.
                        </li>
                        <li>
                          Designed core product flows and implemented key
                          backend and frontend features within a 36 hour build
                          window.
                        </li>
                        <li>
                          Recognized for delivering a practical, high impact
                          solution under extreme time constraints.
                        </li>
                        <li>
                          Coverage:{" "}
                          <a
                            href="https://yourstory.com/2016/07/med4dev-hackathon"
                            target="_blank"
                            rel="noreferrer"
                            style={accentLinkStyle}
                          >
                            YourStory
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <hr />

                {/* ByteCamp */}
                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-12 mb-2">
                      <h4>ByteCamp 2017 SIES GST Annual Hackathon</h4>
                      <div style={{ fontSize: ".9em", color: "#707070" }}>
                        Most Innovative Project Award
                      </div>
                    </div>

                    <div className="col-12">
                      <ul>
                        <li>
                          Designed and built a wearable based system for theme
                          parks to enable real time visitor identification,
                          tracking, and interaction.
                        </li>
                        <li>
                          Implemented Bluetooth Low Energy (BLE) communication
                          between wearable devices and backend services for low
                          power, proximity based interactions.
                        </li>
                        <li>
                          Enabled functionality such as ride access validation,
                          child safety monitoring, and payment like interactions
                          for lockers and in park services.
                        </li>
                        <li>
                          Engineered backend services to ingest, process, and
                          visualize real time event data generated by wearable
                          devices with low latency.
                        </li>
                        <li>
                          Recognized for originality, system design depth, and
                          practical applicability in a competitive hackathon
                          environment.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <hr />

                {/* MSBTE */}
                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-12 mb-2">
                      <h4>MSBTE Regional Level Project Competition 2016</h4>
                      <div style={{ fontSize: ".9em", color: "#707070" }}>
                        Regional Level Recognition
                      </div>
                    </div>

                    <div className="col-12">
                      <ul>
                        <li>
                          Developed a wireless model rocket launch system proof
                          of concept with a base receiving station for safe
                          remote operation.
                        </li>
                        <li>
                          Implemented real time sensor telemetry streaming
                          including pressure, altitude, speed, and temperature
                          data collection.
                        </li>
                        <li>
                          Explored propulsion, fuel considerations, and
                          reliability constraints for repeated launch and data
                          capture cycles.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <hr />

                {/* RoboGalaxy */}
                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-12 mb-2">
                      <h4>
                        RoboGalaxy National Level Robotics Competition 2013
                      </h4>
                      <div style={{ fontSize: ".9em", color: "#707070" }}>
                        National Level Qualification
                      </div>
                    </div>

                    <div className="col-12">
                      <ul>
                        <li>
                          Designed and built a line follower robot capable of
                          autonomously navigating competition tracks using
                          sensor driven control logic.
                        </li>
                        <li>
                          Entered the competition with no prior embedded systems
                          experience and learned core robotics and control
                          concepts within 24 hours.
                        </li>
                        <li>
                          Implemented sensor calibration, basic control
                          algorithms, and motor coordination to achieve reliable
                          path following behavior.
                        </li>
                        <li>
                          Qualified as the youngest team at the national level,
                          demonstrating rapid learning, problem solving, and
                          execution under pressure.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Awards;
